
import { Ref, Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'SideGuide',
})
export default class SideGuide extends Vue {
  @Ref('sideGuide')
  private sideGuide!: HTMLElement

  private isDragging = false
  private position = {
    bottom: 15,
    right: 20,
  }
  private dragPos = {
    startX: 0,
    startY: 0,
    elementX: 0,
    elementY: 0,
  }
  private openServiceMaxMoveRange = 5

  private mounted() {
    this.sideGuide.addEventListener('mousedown', this.onMouseDown.bind(this), false)
    document.addEventListener('mousemove', this.onMouseMove.bind(this), false)
    document.addEventListener('mouseup', this.onMouseUp.bind(this), false)
  }

  private beforeDestroy() {
    this.stopDragging()
  }

  private onMouseDown(e: MouseEvent) {
    this.dragPos.startX = e.clientX
    this.dragPos.startY = e.clientY

    const rect = this.sideGuide.getBoundingClientRect()
    this.dragPos.elementX = rect.x
    this.dragPos.elementY = rect.y

    // 设置拖动状态
    this.isDragging = true
  }

  private onMouseMove(e: MouseEvent) {
    if (!this.isDragging) return

    const diffX = this.dragPos.startX - e.clientX
    const diffY = this.dragPos.startY - e.clientY

    if (Math.abs(diffX) > this.openServiceMaxMoveRange || Math.abs(diffY) > this.openServiceMaxMoveRange) {
      this.sideGuide.style.cursor = 'move'
    }

    // 计算新的位置
    const rect = this.sideGuide.getBoundingClientRect()
    const newRight = document.body.clientWidth - rect.width - this.dragPos.elementX + diffX
    const newBottom = document.body.clientHeight - rect.height - this.dragPos.elementY + diffY

    const moveRangeX = 300
    const moveRangeY = 500

    // 更新元素位置
    this.position.right = newRight > moveRangeX ? moveRangeX : newRight < 0 ? 0 : newRight
    this.position.bottom = newBottom > moveRangeY ? moveRangeY : newBottom < 0 ? 0 : newBottom
  }

  private onMouseUp(e: MouseEvent) {
    // 结束拖动
    this.isDragging = false

    const moveX = Math.abs(this.dragPos.startX - e.clientX)
    const moveY = Math.abs(this.dragPos.startY - e.clientY)
    if (moveX <= this.openServiceMaxMoveRange && moveY <= this.openServiceMaxMoveRange) {
      this.$openCustomerService()
    }

    this.sideGuide.style.cursor = ''
  }

  private stopDragging() {
    this.sideGuide.removeEventListener('mousedown', this.onMouseDown.bind(this), false)
    document.removeEventListener('mousemove', this.onMouseMove.bind(this), false)
    document.removeEventListener('mouseup', this.onMouseUp.bind(this), false)
  }
}
